export function initUploadDropzones(root = document) {
    root.querySelectorAll('[data-upload-dropzone]').forEach(zone => {
        if (zone.dataset.dropBound) return;
        const input = zone.querySelector('[data-upload-input]');
        const text = zone.querySelector('[data-upload-selection]');
        const preview = zone.querySelector('[data-upload-selection-preview]');
        const error = zone.querySelector('[data-upload-selection-error]');
        if (!input || !text || !preview || !error) return;
        zone.dataset.dropBound = '1';
        let urls = [], depth = 0;
        const clearPreview = () => { urls.forEach(url => URL.revokeObjectURL(url)); urls = []; preview.replaceChildren(); };
        const valid = files => {
            const invalid = files.find(file => !['image/jpeg','image/png','image/webp','image/gif'].includes(file.type) || file.size > 12 * 1024 * 1024);
            error.textContent = invalid ? `${invalid.name}: vyber JPG, PNG, WEBP nebo GIF do 12 MB.` : '';
            return !invalid;
        };
        const update = () => {
            const files = Array.from(input.files || []);
            clearPreview();
            if (!valid(files)) { input.value = ''; text.textContent = 'Vyber podporované obrázky.'; return; }
            text.textContent = files.length ? `${files.length} souborů: ${files.map(file => file.name).join(', ')}` : 'Zatím není vybraný žádný soubor.';
            files.slice(0, 6).forEach(file => {
                const image = document.createElement('img');
                image.src = URL.createObjectURL(file); urls.push(image.src);
                image.alt = file.name; image.className = 'h-16 w-full rounded-md object-cover';
                preview.append(image);
            });
        };
        input.addEventListener('change', update);
        input.addEventListener('focus', () => zone.classList.add('ring-2'));
        input.addEventListener('blur', () => zone.classList.remove('ring-2'));
        zone.addEventListener('dragenter', event => { event.preventDefault(); depth++; zone.classList.add('bg-rose-50'); });
        zone.addEventListener('dragover', event => { event.preventDefault(); if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy'; });
        zone.addEventListener('dragleave', event => { event.preventDefault(); if (--depth <= 0) { depth = 0; zone.classList.remove('bg-rose-50'); } });
        zone.addEventListener('drop', event => {
            event.preventDefault(); event.stopPropagation(); depth = 0; zone.classList.remove('bg-rose-50');
            const files = Array.from(event.dataTransfer?.files || []);
            if (!files.length || !valid(files)) return;
            try {
                const transfer = new DataTransfer(); files.forEach(file => transfer.items.add(file));
                input.files = transfer.files; input.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (_) { error.textContent = 'Přetažení není v tomto prohlížeči dostupné. Použij Vybrat soubory.'; }
        });
        input.form?.addEventListener('reset', () => setTimeout(update, 0));
        window.addEventListener('pagehide', clearPreview, { once: true });
        update();
    });
}
